import type { CvCenter } from "@sikhio/shared";
import { useFeed } from "./useFeed";

/**
 * The per-camera CV state — one entry per camera the probe is watching.
 *
 * ONE owner for this feed. The camera wall and the CCTV centre both read
 * it, so it is lifted into App and passed down; two components polling
 * the same endpoint would double the requests for the same bytes.
 *
 * `enabled` is false until one of the two surfaces is actually on screen.
 * The camera wall is collapsed by default, so polling unconditionally
 * would fetch a feed nobody is looking at — cost paid for nothing, which
 * is the same mistake as a decorative panel.
 */
export function useCvCentres(apiBase: string, enabled: boolean) {
  return useFeed<CvCenter>(enabled ? `${apiBase}/api/cctv/cv-events/centers` : null, 15_000);
}
